import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    currentLanguage: string = 'ru';
    ltranslated = {
        'ru' : {},
        'en' : {}
    }
    translated = `
    most-popular ~~ Самые популярные || Most popular
    most-viewed ~~ Самые просматриваемые || Most viewed
    my-podcast ~~ Мои подкасты || My podcasts
    podcast-list ~~ Список подкастов || Podcast List
    
    мaximum-number-of-files ~~ Максимальное количество файлов || Maximum number of files
    maximum-size-of-a-single-file ~~ Максимальный размер одного файла || Maximum size of a single file
    possible-file-types ~~ Возможные типы файлов || Possible file types
    
    view ~~ Посмотреть || View
    edit ~~ Редактировать || Edit
    save ~~ Сохранить || Save
    fullview ~~ На весь экран || Full view
    
    creation-date ~~ Дата создания || Creation date
    author ~~ Автор || Author
    tags ~~ Теги || Tags
  
    create-new-podcast ~~ Создать новый подкаст || Create new podcast
    create-podcast ~~ Создание  подкаста || Create podcast
    logout ~~ Выйти || Log out
    registration  ~~ Регистрация || Registration
    create-account ~~ Создать аккаунт || Create account
    show-description ~~ Показать описание || Show description
    hide-description ~~ Скрыть описание || Hide description
    embed-in-your-website ~~ Встроить в свой сайт || Embed in your website
    hide-instruction ~~ Скрыть инструкцию || Hide instruction
    edit-podcast-file-upload ~~ Редактирование подкаста (загрузка файлов) || Edit podcast (file upload)
    create-podcast-file-upload ~~ Создание нового подкаста (загрузка файлов) || Create new podcast (file upload)
    
    podcast-text ~~ Текст подкаста || Podcast text
    podcast-text-instruction ~~ Каждый абзац будет отдельной секцией, к которой можно будет привязать позицию в аудиофайле и изображение. || Each paragraph will be a separate section to which you can bind a position in the audio file and an image.
    name ~~ Название || Name
    description ~~ Описание || Description
    tags-comma-separated ~~ Теги (через запятую) || Tags (comma separated)
    
    save-podcast-and-go-to-markup ~~ Сохранить подкаст и перейти к разметке || Save podcast and go to markup
    
    images-and-audio-file-for-podcast ~~ Изображения и аудиофайл для подкаста || Images and audio file for podcast
    upload-files ~~ Загрузить файлы || Upload files
    or-drag-files-here ~~ или перетащите сюда файлы || or drag files here
    required ~~ обязательно для заполнения || required
    phone ~~ Телефон || Phone number
    password ~~ Пароль || Password
    login ~~ Войти || Log in
    forgot-your-password ~~ Забыли пароль || Forgot your password
    password-reminder ~~ Напоминание пароля || Password reminder
    enter-e-mail-specified-during-registration ~~ Введите e-mail, указанный при регистрации ||  Enter e-mail, specified during registration
    enter-email-instruction ~~ Введите e-mail, указанный при регистрации и мы вышлем на этот адрес ссылку для восстановления пароля || Enter the e-mail specified during registration and we will send a link to this address to this address.
    send-password ~~ Выслать пароль || Send password  
    
    first-name ~~ Имя || First name
    last-name ~~ Фамилия || Last name
    
    authorization ~~ Авторизация || Authorization
    agree-with-terms ~~ Нажимая кнопку "Зарегистрироваться", Вы соглашаетесь с политикой конфиденциальности и политикой обработки персональных данных || By clicking on the "Register" button, you agree to the privacy policy and personal data processing policy.
    password-send-email ~~ На Ваш адрес  было выслано письмо с инструкциями на восстановление пароля || An email was sent to your address with instructions for password recovery
    
    view-count ~~ просмотров || view
    
    link ~~ привязать || link

    podcast-create-success ~~  Подкаст успешно сохранен! Вы можете  <a href="/view/$val1$">перейти к его просмотру</a> || Podcast successfully saved! You can go to <a href="/view/$val1$">view it</a> .
    podcast-information ~~ Информация по подкасту || About   
    
    is-public ~~ Опубликован || Published
    
    uploader-error-1 ~~ Для создания подкаста необходимо, чтобы был загружен хотя бы один аудиофайл файл в формате mp3. || To create a podcast, you need to download at least one audio file in mp3 format.
    uploader-error-2 ~~ В процессе загрузки файлов возникли ошибки. Пожалуста попробуйте еще раз догрузить файлы, помеченные красным. || Errors occurred while uploading files. Please try again to upload files marked in red.
    uploader-error-3 ~~ Вы должны загрузить хотя бы одно изображение и один аудиофайл. || You must upload at least one image and one audio file.
    uploader-error-4 ~~ Проверьте правильность заполнения полей. || Check the correctness of the fields.
    
    remove-podcast-3 ~~ Удалить подкаст || Remove podcast
    remove-podcast ~~ Удаление подкаста || Remove podcast
    remove-podcast-2 ~~ Удаление подкаста прошло успешно || Podcast deleted successfully 
    remove-podcast-4 ~~ Вы действиетльно хотите навсегда удалить подкаст? || Are you shure remove podcast? 
    remove-podcast-5 ~~ Да, удалить || Yes, remove
    remove-podcast-6 ~~ Нет, не удалять || No, don't remove 
    
    edit-available ~~ Доступные для редактирования || Available for editing 
    
    public-link ~~ Подкаст всегда будет доступен по ссылке  <br />http://tredia.ru || Permanent podcast link <br />http://tredia.org
    
  `;

    constructor() {
        this.getCurrentLanguage();
    }

    translate(phraseId:string, replace:any=null ) {
        let ltranslated = this._getPrepared();
        if(!this.ltranslated[this.currentLanguage]){
            console.error('WRONG LANGUAGE: ' + this.currentLanguage);
            return;
        }
        if(!this.ltranslated[this.currentLanguage][phraseId]){
            console.error('PHRASE ID -' + phraseId + '- NOT TRANSLATED FOR LANGUAGE -' + this.currentLanguage );
        }

        let ert = this.ltranslated[this.currentLanguage][phraseId];

        if(replace){
            for (var prop in replace) {
                ert = ert.replace(new RegExp('\\$val1\\$'), replace[prop]);
            }
        }
        return ert;
    }

    getCurrentLanguage()
    {
        this.currentLanguage = window.location.host.match(/\.org/) ? 'en' : 'ru';
        // this.currentLanguage = 'en';
        return this.currentLanguage;
    }

    _getPrepared()
    {
        if(!('most-popular' in this.ltranslated)){
            this.translated.split("\n").forEach((str) => {
                if(!str.trim()) return;
                let ptr = str.split('~~');
                let versions = ptr[1].trim().split('||');
                this.ltranslated['ru'][ptr[0].trim()] = versions[0].trim();
                if(!versions[1]){
                    console.error('Wrong key:' + ptr[0].trim());
                }else{
                    this.ltranslated['en'][ptr[0].trim()] = versions[1].trim();
                }
            });
        }
        return this.ltranslated;
    }
}